import '../../select/v1/select'
import '../../floating-label/v1/floating-label'
import DatePickerFactory from 'jquery-datepicker'
import DatePickerFactoryFR from 'jquery-datepicker/i18n/jquery.ui.datepicker-fr'

$.fn.Form = function(obj) {
  let self = this

  if (self.data('form')) {
    return self
  }

  self.action = self.find('input[name="action"]').val()
  self.fields = {}
  self.repeaters = {}
  self.steps = undefined

  self.el = {
    inputs: undefined,
    fields: undefined,
    submit: undefined,
  }

  self.get_options = function() {
    return obj.options
  }

  self.get_object = function() {
    return obj
  }

  self.get_form_data = function() {
    let data = new FormData()
    for (let fieldName in self.fields) {
      let formValue = self.get_form_value(fieldName)
      if (Array.isArray(formValue)) {
        let strippedName = fieldName.replace('[]', '')
        formValue.forEach(function(singleValue) {
          data.append(strippedName + '[]', singleValue)
        })
      } else {
        data.append(fieldName, formValue)
      }
    }
    for (let fieldName in self.repeaters) {
      let repeaterField = self.repeaters[fieldName]
      data.append(fieldName, JSON.stringify(repeaterField.get_repeater_value()))
    }
    return data
  }

  self.get_form_value = function(fieldName) {
    let field = self.fields[fieldName]
    if (Array.isArray(field)) {
      let values = []
      field.forEach(function(element) {
        if (element.attr('type') == 'checkbox' && element.closest('.field').hasClass('field--type-true_false')) {
          values = element.prop('checked') ? element.val() : 0
        } else if (element.attr('type') == 'radio' && element.prop('checked')) {
          values = element.val()
        } else if (element.attr('type') == 'checkbox' && element.prop('checked')) {
          values.push(element.val())
        }
      })
      return values
    } else if (field.attr('type') == 'file') {
      let fileInfo = field.get(0).files
      if (fileInfo == undefined || fileInfo.length === 0) {
        fileInfo = ''
      } else if (fileInfo.length === 1) {
        fileInfo = fileInfo[0]
      } else if (fileInfo.length > 1) {
        let files = []
        for (let i = 0; i < fileInfo.length; i++) {
          files.push(fileInfo[i])
        }
        fileInfo = files
      }
      return fileInfo
    } else if (field.attr('type') == 'number') {
      let numericValue = parseInt(field.val(), 10)
      return isNaN(numericValue) ? '' : numericValue
    }
    return field.val()
  }

  self.handle_submit = function(e) {
    e.preventDefault()
    self.disable_fields()
    self.addClass(obj.options.submitting_class)
    $('.field--invalid').removeClass('field--invalid')
    $('.field-error, .form-error').slideUp(180, function() {
      $(this).remove()
    })
    let preventSubmit = false
    if (obj.options.onBeforeSubmit != undefined) {
      preventSubmit = obj.options.onBeforeSubmit(self)
    }
    if (preventSubmit === 'prevent') {
      self.enable_fields()
      self.removeClass(obj.options.submitting_class)
      return
    }
    $.ajax({
      url: obj.options.ajax_url,
      type: 'POST',
      enctype: self.attr('enctype') ? self.attr('enctype') : 'text/plain',
      data: self.get_form_data(),
      processData: false,
      contentType: false,
      cache: false,
      success: self.handle_response,
    })
    if (obj.options.onSubmit != undefined) {
      obj.options.onSubmit(self)
    }
  }

  self.handle_response = function(response) {
    self.removeClass(obj.options.submitting_class)
    if ('feedback' in response) {
      self.handle_feedback(response)
    } else if (response.success) {
      self.handle_success(response)
    } else {
      self.handle_error(response)
    }
  }

  self.handle_success = function(response) {
    if (obj.options.steps.use_steps && obj.options.steps.submit_steps && self.steps != undefined) {
      if (response.form_id) {
        self.find('input[name="steps_form_id"]').val(response.form_id)
      }
      if (response.form_step == self.steps.max_steps) {
        if (obj.options.onSuccess != undefined) {
          obj.options.onSuccess(response, self)
        }
      } else {
        self.enable_fields()
        self.steps.next_step()
      }
    } else if (obj.options.ajax_redirect && response.redirect) {
      location.href = response.redirect
    } else {
      if ('message' in response) {
        self.fadeOut(250, function() {
          let $success = $(response.message)
          self.after($success.fadeIn(250))
          self.remove()
        })
      }
      if (obj.options.onSuccess != undefined) {
        obj.options.onSuccess(response, self)
      }
    }
  }

  self.handle_error = function(response) {
    self.enable_fields()
    if (response.error != undefined) {
      self.prepend($(response.error))
    }
    let first_error = undefined
    for (let fieldName in response.errors) {
      let input = self.fields[fieldName],
        field_element = $(input).parents('.field').addClass('field--invalid')
      if (field_element.length) {
        field_element.after($(response.errors[fieldName]))
      } else {
        field_element = self.find('.field-container--' + fieldName)
        field_element.addClass('field--invalid')
        field_element.append($(response.errors[fieldName]))
      }
      if (first_error == undefined) {
        first_error = field_element
      }
    }
    if (obj.options.steps.use_steps && self.steps != undefined && first_error != undefined) {
      self.steps.go_to_field(first_error)
    }
    if (obj.options.auto_scroll && first_error != undefined) {
      let windowTarget = $('.form-error:visible, .field--invalid:visible').offset().top - obj.options.auto_scroll_offset
      if ($(window).scrollTop() > windowTarget) {
        $('html, body').animate({
          scrollTop: windowTarget + 'px',
        }, 450)
      }
    }
    if ('grecaptcha' in window) {
      grecaptcha.reset()
      $('input[name="recaptcha"]').val('')
    }
    if (obj.options.onError != undefined) {
      obj.options.onError(response, self)
    }
  }

  self.handle_feedback = function(response) {
    if (response.form_id) {
      self.find('input[name="steps_form_id"]').val(response.form_id)
    }
    if (obj.options.onFeedback != undefined) {
      obj.options.onFeedback(response, self)
    } else {
      self.handle_success(response)
    }
  }

  self.disable_fields = function() {
    self.el.fields.addClass('field--disabled')
    self.el.inputs.prop('disabled', true)
    self.el.submit.prop('disabled', true)
    if (obj.options.blocked_class) {
      self.addClass(obj.options.blocked_class)
    }
  }

  self.enable_fields = function() {
    self.el.fields.removeClass('field--disabled')
    self.el.inputs.prop('disabled', false)
    self.el.submit.prop('disabled', false)
    if (obj.options.blocked_class) {
      self.removeClass(obj.options.blocked_class)
    }
  }

  self.register_fields = function() {
    self.el = {
      inputs: self.find(':input:not(.repeater-container :input)'),
      fields: self.find('.field:not(.repeater-container .field)'),
      submit: self.find('[type="submit"]'),
    }
    self.fields = {}
    self.el.inputs.each(function() {
      if ($(this).attr('type') == 'radio' || $(this).attr('type') == 'checkbox') {
        if (self.fields[$(this).attr('name')] == undefined) {
          self.fields[$(this).attr('name')] = []
        }
        self.fields[$(this).attr('name')].push($(this))
      } else if ($(this).attr('name')) {
        self.fields[$(this).attr('name')] = $(this)
      }
    })
  }

  return function() {
    /* Can be called again */
    self.register_fields()

    /* Check for repeater first to detach template */
    if (obj.options.repeater_field) {
      self.find('.repeater-container').each(function() {
        let repeater = $(this).RepeaterField(obj)
        self.repeaters[repeater.name] = repeater
      })
    }

    /* Submit in ajax */
    if (obj.options.use_ajax) {
      self.on('submit', self.handle_submit)
    }

    /* Initialize floating labels */
    if (obj.options.floating_labels === true) {
      self.find('.field:not(.field--type-file)').each(function() {
        $(this).FloatingLabel()
      })
    } else if (obj.options.floating_labels) {
      self.find(obj.options.floating_labels).each(function() {
        $(this).FloatingLabel()
      })
    }

    /* Initialize select elements */
    if (obj.options.select_element) {
      self.find('.field select').each(function() {
        $(this).Select()
      })
    }

    /* Initialize date picker elements */
    if (obj.options.date_picker) {
      obj.options.date_picker = $.extend({
        dateFormat: 'yy-mm-dd',
        nextText: '&#x25b6;&#xfe0e;', // ▶ without emoji rendering
        prevText: '&#x25C0;&#xfe0e;', // ◀ without emoji rendering
      }, obj.options.date_picker)
      DatePickerFactory($)
      self.find('.field--type-date_picker input').each(function() {
        $(this).datepicker(obj.options.date_picker)
        if (obj.options.locale == 'fr') {
          DatePickerFactoryFR($)
        }
      })
    }

    /* Initialize form steps */
    if (obj.options.steps.use_steps) {
      self.steps = self.find('.form-steps').FormSteps(self)
    }

    /* Initialize form */
    self.data('form', self)
    if (obj.options.onInit != undefined) {
      obj.options.onInit(self)
    }
    return self
  }()
}

export default function(selector, options) {
  let obj = this
  obj.form = undefined

  /*
  * Default options
  */
  if (selector == undefined) {
    selector = 'form'
  }
  if (options == undefined) {
    options = {}
  }
  obj.options = $.extend(true, {
    locale: 'fr',
    use_ajax: true,
    steps: {
      use_steps: false,
      submit_steps: false,
      initial_step: 1,
    },
    ajax_url: (typeof site_l10n !== 'undefined' && site_l10n.ajax_url) ? site_l10n.ajax_url : '/wp-admin/admin-ajax.php',
    ajax_redirect: true,
    fields_selector: ':input',
    auto_scroll: true,
    auto_scroll_offset: 30,
    blocked_class: false,
    submitting_class: '--submitting',
    floating_labels: false,
    select_element: true,
    repeater_field: false,
    date_picker: false,
    onInit: undefined,
    onBeforeSubmit: undefined,
    onSubmit: undefined,
    onSuccess: undefined,
    onError: undefined,
    onStep: undefined,
  }, options)

  /*
  * Initializer
  */
  $(selector).each(function() {
    obj.form = $(this).Form(obj)
  })

  obj.getForm = function() {
    return obj.form
  }

  return obj
}
